export default __webpack_public_path__ + "static/media/VIP_green.a2a28305.png";